import { JSX, useEffect } from "react";

function Analytics(): JSX.Element {
	useEffect(() => {
		window.setTimeout(() => {
			const stat = document.createElement("script");
			stat.async = true;
			stat.src =
				"https://hm.baidu.com/hm.js?" +
				(window.location.hostname === "beta.limestart.cn"
					? "87b3a6114a65acef7b2835db3f4cabec"
					: "df0646f41ad5dc639470ce2f4cda683c");
			document.body.appendChild(stat);
		}, 1000);
	}, []);

	return <></>;
}

export default Analytics;
